import type { PartSvgProps } from './types'

export default function LightSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 100,
  height = 60
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 100 60" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main body cylinder */}
      <rect x="18" y="16" width="64" height="28" rx="8"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Knurling marks */}
      {[28, 38, 48, 58, 68].map((x) => (
        <line key={x} x1={x} y1={16} x2={x} y2={44}
              stroke={stroke} strokeWidth="0.8" />
      ))}
      {/* Bezel ring (front) */}
      <ellipse cx="18" cy="30" rx="8" ry="14"
               fill={fill} stroke={accent} strokeWidth="1.5" />
      {/* Lens */}
      <circle cx="18" cy="30" r="6" fill="none" stroke={accent} strokeWidth="1" />
      {/* Tail cap (rear) */}
      <ellipse cx="82" cy="30" rx="7" ry="14"
               fill={fill} stroke={stroke} strokeWidth="1.2" />
      {/* Tail cap button */}
      <circle cx="89" cy="30" r="4" fill={fill} stroke={accent} strokeWidth="1" />
      {/* Mount rail clamp */}
      <rect x="30" y="44" width="40" height="8" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
